import React from 'react'
import RightArrow from '../../../images/right-arrow'
import { getReadingTime } from '../../../domain/useCases/filterAuthorBlogsByAuthorName'
import { removeTags } from '../../../utils/removeTags'
import sanitizeHtml from 'sanitize-html'
import { isNonEmptyString } from '../../../utils/checks'

const ArticleCard = ({
  slug,
  url,
  title,
  content,
  readingTime,
  excerpt,
  categories,
  coverImage
}) => {
  const calculatedReadingTime = readingTime || getReadingTime(content)
  const preview = excerpt || content?.slice(0, 125) + '...'

  const getCategoryType = (categories) => {
    const categoryMap = {
      news: 'news',
      voices: 'voices',
      'circle-of-chairs': 'circle-of-chairs',
      podcasts: 'podcasts'
    }

    const matchingCategory = Array.isArray(categories?.nodes)
      ? categories?.nodes.find((category) => categoryMap[category.slug])
      : null

    return matchingCategory ? categoryMap[matchingCategory.slug] : 'resources'
  }
  const articleImage = isNonEmptyString(coverImage)
    ? coverImage
    : `https://res.cloudinary.com/rehabpath/image/upload/c_lfill,q_30,f_auto,h_800,w_3200/${slug}`

  const resolvedUrl = url || `/${getCategoryType(categories)}/${slug}/`

  return (
    <div
      className="w-full cursor-pointer rounded-2xl border border-gray-300 transition-shadow duration-300 
        ease-in-out hover:shadow-[0_4px_36px_rgba(76,76,77,0.14)] active:bg-gray-50 sm:mt-8 
        sm:w-[292px]"
    >
      <a
        className="no-underline"
        href={resolvedUrl}
      >
        <div>
          <img
            src={articleImage}
            loading="lazy"
            className="h-[184px] w-full overflow-hidden rounded-t-2xl object-cover"
          />
        </div>

        <div className="flex h-[254px] flex-col items-start p-6">
          <div>
            <div className="mb-2 line-clamp-3 font-FieldsVariable text-xl font-medium leading-7 tracking-[0.3px] text-gray-1100 hover:underline">
              {title}
            </div>
          </div>
          <div>
            <p className="line-clamp-3 self-stretch overflow-hidden text-sm text-gray-800">
              {removeTags(sanitizeHtml(preview))}
            </p>
          </div>
          <div className="relative size-full">
            <div className="text-sm text-gray-700">
              <div className="absolute bottom-0 inline">
                {calculatedReadingTime} min read
              </div>
              <div className="absolute bottom-0 right-0">
                <RightArrow />
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  )
}

export default ArticleCard
